
export default {
  props: {
    text: String,
    directionRight: Boolean
  }
}
